<p-dialog
    [ngStyle]=""
    [focusOnShow]="false"
    [modal]="true"
    appendTo="body"
    (onShow)="onShow()"
    (onHide)="onHide()"
    [(visible)]="display"
    [header]="headerText"
    [style]="{ minWidth: minWidth }"
    [draggable]="draggable"
    [styleClass]="internalFooterBar ? 'hide-dialog-footer-template ' + popupClass : popupClass"
    [contentStyle]="{
        minHeight: minHeight,
        'overflow-x': 'hidden',
        'overflow-y': allowOverflow ? 'auto' : 'hidden'
    }"
    closeIcon="ci ci-close ci--blue"
    [resizable]="false"
    [closeOnEscape]="closeOnEscape"
    [closable]="closableWithX"
    [class]="popupClass">
    <ng-template #header>
        <ng-content select="div[customHeader]"></ng-content>
        <div class="sera-popup__header">
            <i
                *ngIf="headerIcon"
                class="{{ headerIcon }}"></i>
            <ds-icon
                *ngIf="dsHeaderIcon"
                [icon]="dsHeaderIcon">
            </ds-icon>
            <label class="p-dialog-title">{{ headerText }}</label>
            <div
                class="display-end"
                *ngIf="showLimitExceeded">
                <ds-hint [tone]="'critical'">{{ 'PAGE.ANALYSIS.RI_LIMIT_EXCEEDED.LBL' | translate }}</ds-hint>
            </div>
            <sera-ri-value
                *ngIf="showRIComponent"
                [ngClass]="{ 'display-end': !showLimitExceeded }"
                [label]="'PAGE.ANALYSIS.CRITERION_RZ.LBL' | translate"
                [value]="rzValue"
                [color]="color" />
        </div>
    </ng-template>
    <ng-content></ng-content>
    <ng-template #footer>
        <ng-content select="sera-button[footerButton]"></ng-content>
        <ng-content select="ds-button[footerButton]"></ng-content>
    </ng-template>
</p-dialog>
